import { useContext, useEffect } from "react";
import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { myProfileApi } from "services/user";

const LoaderContext = createContext({});

const defaultDetails = {
    _id: "",
    name: "",
    mobile: "",
    profile: ""
}

const UserProvider = ({ children }) => {
    const token = localStorage.getItem("baby_glow_admin_token");
    const [user, setUserData] = useState(defaultDetails);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const setUser = (data) => {
        if (data) {
            setUserData(prev => ({ ...prev, ...data }));
            setLoading(false);
        } else if (data === null) {
            setUserData(defaultDetails);
        }
    }

    const isLoggedIn = user._id.length ? true : false;

    const fetchData = async () => {
        try {
            const data = await myProfileApi({});
            setUser(data?.data?.data);
        } catch (error) {
            setLoading(false);
            console.log({ error });
        }
    }

    const logout = () => {
        setUserData(defaultDetails);
        localStorage.removeItem("baby_glow_admin_token");
        navigate("/");
    }

    console.log({ user });


    const havePermission = (permission) => {
        if (user?.role?.name?.includes("SUPER_ADMIN")) {
            return true;
        }

        if (user?.role?.resources?.includes(permission)) {
            return true
        }
        return false;
    }

    useEffect(() => {
        if (token) {
            fetchData();
        } else {
            setLoading(false);
        }
    }, []);

    return (
        <LoaderContext.Provider value={{ user, setUser, havePermission, isLoggedIn, logout }}>
            {
                loading
                    ?
                    <div style={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>

                        <div>
                            Loading...
                        </div>
                    </div>
                    :
                    children
            }
        </LoaderContext.Provider>
    );
};

const useUser = () => useContext(LoaderContext);

export default useUser;
export { UserProvider };